import { createContext, useContext, useEffect, useState } from "react";
import api, { pingBackend } from "../lib/api";

const AuthContext = createContext(null);

function getUserFromStorage() {
  const token = localStorage.getItem("lss_token");
  const cached = localStorage.getItem("lss_user");
  if (token && cached) {
    try { 
      return JSON.parse(cached); 
    } catch { 
      return false; 
    }
  }
  return false;
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => getUserFromStorage());

  useEffect(() => {
    pingBackend();
    const token = localStorage.getItem("lss_token");
    if (!token) {
      setUser(false);
    } else {
      api.get("/auth/me")
        .then((res) => {
          if (res.data) {
            setUser((prev) => ({ ...(prev || {}), ...res.data }));
          }
        })
        .catch(() => {
          localStorage.removeItem("lss_token");
          localStorage.removeItem("lss_user");
          setUser(false);
        });
    }
  }, []);

  const login = async (email, password) => {
    try {
      const backendRes = await api.post("/auth/login", { email, password });
      const data = backendRes.data;
      if (data && data.token) {
        const userData = {
          id: data.id,
          email: data.email,
          name: data.name || (data.role === "owner" ? "Salon Owner" : "Salon Manager"),
          role: data.role || "owner",
          token: data.token,
        };
        localStorage.setItem("lss_token", data.token);
        localStorage.setItem("lss_user", JSON.stringify(userData));
        setUser(userData);
        return userData;
      }
      throw new Error("Invalid response from server");
    } catch (err) {
      throw err;
    }
  };

  const logout = async () => {
    localStorage.removeItem("lss_token");
    localStorage.removeItem("lss_user");
    try { await api.post("/auth/logout"); } catch { }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
